import SocialButton from './SocialButton'

export default SocialButton
// eslint-disable-next-line import/export
export * from './SocialButton'
